module.exports = __webpack_public_path__ + "static/media/money-transfer-pic.9e27a5fa.png";